import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import "./App.css";
import AppRoutes from "./AppRoutes";
import AuthContextProvider from "./contexts/auth-context";
import { BrowserRouter } from "react-router-dom";
import ShopContextProvider from "./contexts/shop-context";


function App() {
  return (
    <div className="App app-shell">
      <BrowserRouter>
        <ShopContextProvider>
          <AuthContextProvider>
            <AppRoutes />
          </AuthContextProvider>
        </ShopContextProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
